import { useState } from "react";
import { PlanningModalContainer } from "..";
import { useIntl } from "react-intl";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "src/app/utils/AssetHelpers";
import { usePlanningNoSetByManager } from "src/app/hooks";
import { SimpleModal } from "src/app/components";
import RequestPlanningForm from "src/app/components/PlanningForm/RequestPlanningForm";
import { Form, Formik, FormikHelpers } from "formik";
import {
    Planning,
    UpsertRequestPlanning,
    UpsertRequestPlanningSchema,
} from "src/app/types/planning";

const PlanningContainer = () => {
    const [showRequestsModal, setShowRequestsModal] = useState(false);
    const [showKeywordModal, setShowKeywordModal] = useState(false);
    const [planningChoosed, setPlanningChoosed] = useState<Planning>();
    const { formatMessage } = useIntl();
    const { planning, loading, refresh: refreshPlanning } = usePlanningNoSetByManager();

    const siteListOptions = planning.map((el) => ({
        label: el.moneySite.domain,
        value: el.id,
        months: el.months,
        moneySite: el.moneySite,
        orderType: el.orderType,
    }));
    const handleCloseRequestModal = () => {
        setShowRequestsModal(false);
    };
    const handleCloseKeywordsModal = () => {
        setShowKeywordModal(false);
        setPlanningChoosed(undefined);
        refreshPlanning();
    };
    const handlerChangePlanning = (planningId?: number) => {
        if (planningId) setPlanningChoosed(planning?.find((el) => el.id === planningId));
    };

    const handleSubmit = (_values: UpsertRequestPlanning, formikHelpers: FormikHelpers<object>) => {
        setShowKeywordModal(true);
        formikHelpers.resetForm();
    };

    return (
        <>
            <span className="planningText" onClick={() => setShowRequestsModal(true)}>
                {planning.length > 0 && (
                    <>
                        <SVG
                            className="pulse-animation"
                            src={toAbsoluteUrl("/media/icons/duotune/general/gen044.svg")}
                        />

                        {formatMessage({ id: "dashboard.planning" })}
                    </>
                )}
            </span>
            <SimpleModal
                entityName={formatMessage({ id: "common.entity.planning" })}
                formId="requestPlanningForm"
                handleClose={() => {
                    handleCloseRequestModal();
                }}
                buttonConfirmationLabel={formatMessage({ id: "common.action.launchPlanning" })}
                showModal={showRequestsModal}
            >
                <Formik
                    initialValues={UpsertRequestPlanningSchema.getDefault()}
                    validationSchema={UpsertRequestPlanningSchema}
                    onSubmit={(value: object, formikHelpers) =>
                        handleSubmit(value as UpsertRequestPlanning, formikHelpers)
                    }
                >
                    <Form id="requestPlanningForm">
                        <RequestPlanningForm
                            planningOptions={{ options: siteListOptions, loading }}
                            handlerChangePlanning={handlerChangePlanning}
                        />
                    </Form>
                </Formik>
            </SimpleModal>
            {planningChoosed && (
                <PlanningModalContainer
                    showModal={showKeywordModal}
                    planning={planningChoosed}
                    handleClose={handleCloseKeywordsModal}
                />
            )}
        </>
    );
};

export default PlanningContainer;
